import Video from './Video.component';

export default Video;
